import chance from 'chance';
import ChanceInterface = Chance.Chance;
import {Collection} from "collect.js";

const base = chance();

export type ExtendedChanceStatic = ChanceInterface & {
  randomEnum: <T>(anEnum: T) => T[keyof T],
  pickoneByFieldProbability: <T>(items: T[] | Collection<T>, field: (item: T) => number) => T,
}

const chanceInstance: ExtendedChanceStatic = Object.assign(base, {
  randomEnum: <T>(anEnum: T): T[keyof T] => {
    let enumValues = Object.keys(anEnum)
      .map(n => Number.parseInt(n))
      .filter(n => !Number.isNaN(n)) as unknown as T[keyof T][];

    if (enumValues.length === 0) {
      enumValues = Object.values(anEnum);
    }

    const randomIndex = Math.floor(Math.random() * enumValues.length);

    return enumValues[randomIndex];
  },
  pickoneByFieldProbability: <T>(items: T[] | Collection<T>, field: (item: T) => number): T => {
    let limit = 0;

    const map: [number, T][] = [];

    for (const item of items) {
      limit += field(item);
      map.push([limit, item]);
    }

    const random = chanceInstance.integer({min: 1, max: limit});

    return map.find(([limit]) => limit >= random)![1];
  }
});

export default chanceInstance;

export function basePowerOf10(x: number) {
  let power = 1;
  while (x > 10 ** (power + 1) - 1) {
    power++;
  }

  return power + 1;
}

export function roundFront(x: number, frontDigits = 3) {
  const power = Math.max(0, basePowerOf10(x) - frontDigits);

  return Math.round(x / (10 ** power)) * (10 ** power);
}